import { useToast } from '@/hooks/use-toast';
import { getErrorMessage } from '@/lib/utils';
import { useCallback } from 'react';

/**
 * Custom hook for consistent error handling across the application
 */
export const useErrorHandler = () => {
  const { toast } = useToast();

  const handleError = useCallback((error: any, customTitle?: string) => {
    const message = getErrorMessage(error);
    
    toast({
      title: customTitle || "Error",
      description: message,
      variant: "destructive",
      duration: 1000
    });
    
    // Log error for debugging
    console.error('Error handled:', error);
    
    return message;
  }, [toast]);

  const handleSuccess = useCallback((message: string, title = "Success") => {
    toast({
      title,
      description: message,
      duration: 1000
    });
  }, [toast]);

  const handleValidationError = useCallback((errors: Record<string, string>) => {
    const firstError = Object.values(errors)[0];
    if (firstError) {
      toast({
        title: "Validation Error",
        description: firstError,
        variant: "destructive",
        duration: 1000
      });
    }
  }, [toast]);

  return {
    handleError,
    handleSuccess,
    handleValidationError,
  };
};